import React, { useState, useEffect } from "react";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { stateFromHTML } from "draft-js-import-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { BlueButton } from "../Buttons";

interface EditableContentProps {
  initialContent: string;
  onSave: (html: string) => void;
  height?: string;
  resetEditor?: boolean;
}

const TextTemplate: React.FC<EditableContentProps> = ({
  initialContent,
  onSave,
  height,
  resetEditor = false, 
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [isEditor, setIsEditor] = useState(false);

  useEffect(() => {
    if (initialContent) {
      const contentState = stateFromHTML(initialContent);
      setEditorState(EditorState.createWithContent(contentState));
    }
  }, [initialContent]);

  useEffect(() => {
    if (resetEditor) {
      setEditorState(EditorState.createEmpty());
    }
  }, [resetEditor]);

  const toggleEdit = () => {
    setIsEditor(!isEditor);
  };

  const saveEdit = () => {
    const updatedHtml = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    onSave(updatedHtml);
    setIsEditor(false);
      setEditorState(EditorState.createEmpty());
  };

  const onEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState);
  };

  return (
    <div>
      {isEditor ? (
        <div
          className={`${
            height ? `h-[${height}] border pl-2 overflow-y-auto` : "h-auto"
          } min-h-[200px]`}
        >
          <Editor
            editorState={editorState}
            onEditorStateChange={onEditorStateChange}
            wrapperClassName="wrapper-class"
            editorClassName="editor-class"
            toolbarClassName="toolbar-class"
          />
          <div className="w-[100px] mx-auto">
            <BlueButton text="Save HTML" onClick={saveEdit} />
          </div>
        </div>
      ) : (
        <div
          onClick={toggleEdit}
          className={`p-4 bg-desaturated-grey cursor-pointer border rounded-lg min-h-[100px] ${
            height ? `h-[${height}] overflow-y-auto` : "h-auto"
          }`}
          dangerouslySetInnerHTML={{
            __html: initialContent ? initialContent : "<p>Click to set HTML Message</p>",
          }}
        />
      )}
    </div>
  );
};

export default TextTemplate;
